import ScrollReveal from './animations/ScrollReveal';
import Header from './components/Header';
import SmoothScroll from './singleton/SmoothScroll';
import WindowSize from './singleton/WindowSize';
import HomeCarousel from './components/HomeCarousel';
import HomeCards from './components/HomeCards';

class Website {
  $body: JQuery<HTMLElement>;
  $links: JQuery<HTMLElement>;
  header: Header;
  smoothScroll: typeof SmoothScroll;
  private windowSize: WindowSize;

  constructor() {
    this.$body = $('body');
    this.$links = $('a');
    this.header = new Header();

    // Activate the smooth scrolling feature.
    this.smoothScroll = SmoothScroll;
    this.windowSize = WindowSize.getInstance();

    this.initObservers();
    this.initScrollingLinks();

    // home carousel
    $('.home-carousel').each((index, element) => {
      new HomeCarousel(element);
    });
    // home cards
    $('.home-cards').each((index, element) => {
      new HomeCards(element);
    });
  }

  initScrollingLinks() {
    this.$links.on('click', this.linkClicked.bind(this));
    this.scrollOnPageLoad();
  }

  linkClicked(e: JQuery.ClickEvent) {
    const $cur = $(e.currentTarget);
    const href = $cur.attr('href');
    if (!href) return;
    const hrefArr = href.split('#');
    const { pathname, origin, host } = window.location;

    // If the href is empty or just a hash, or if it's not a hash but the
    // path doesn't match the current page, do nothing.
    if (
      !href ||
      href === '#' ||
      (!href.startsWith('#') && !href.includes('#')) ||
      (!href.startsWith('#') &&
        hrefArr[0] !== pathname &&
        hrefArr[0] !== origin + pathname &&
        hrefArr[0] !== '//' + host + pathname)
    ) {
      return;
    }

    const $target = href.startsWith('#') ? $(href) : $(`#${hrefArr[1]}`);
    if ($target.length) {
      e.preventDefault();

      if (this.header.headerIsOpened) {
        this.header.closeNav();
      }

      this.smoothScroll.scrollToSection($target);

      // update url hash
      // window.history.pushState(null, '', href);
    }
  }

  scrollOnPageLoad() {
    const { hash } = window.location;

    if (!hash || hash === '#') return;
    const $target = $(hash);
    if (!$target.length) return;

    setTimeout(() => {
      this.smoothScroll.scrollToSection($target);
    }, 200);
  }

  initObservers() {
    new ScrollReveal(
      $(
        '[data-visibility]:not([data-is-visible]), [data-visibility-inside]>*:not([data-is-visible])',
      ),
    );
  }
}

$(function () {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const website = new Website();
});
